import moment from 'moment'
import {
  CancelMeterModel,
  CUPSModel,
  MeterModel,
  UseModel
} from '../../api/Argentia/model/contracts'
import { mapUsesRequest } from '../uses/uses.mapper'
import { MeterModelRequest } from './meters.model'

export const mapUsesFromCups = (cup: CUPSModel | undefined, meterID: number): UseModel[] => {
  return (
    cup?.meters
      ?.find(meter => meter.id === meterID)
      ?.uses?.map(use => ({ ...use, meterId: meterID }) as UseModel) ?? []
  )
}

export const mapMeterRequest = (meter: MeterModel): MeterModelRequest => {
  return {
    ...meter,
    startDate: meter.startDate ? moment(meter.startDate).format('YYYY-MM-DD') : undefined,
    endDate: meter.endDate ? moment(meter.endDate).format('YYYY-MM-DD') : undefined,
    uses: mapUsesRequest(meter.uses)
  }
}

export const mapMetersFromCups = (cup: CUPSModel | undefined): MeterModel[] => {
  return cup?.meters?.map(meter => meter as MeterModel) ?? []
}

export const mapCancelMeterRequest = (meter: CancelMeterModel): CancelMeterModel => {
  return {
    id: meter.id,
    endDate: meter.endDate
  }
}
